import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FeatureTogglesProvider } from './contexts/FeatureTogglesContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import './i18n';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <FeatureTogglesProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </FeatureTogglesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
